<template>
    <div class="wechat_management_wrap">
       <div class="wechat_management_setting">
           <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">
               <div class="title">
                   <span>首页轮播图</span>
               </div>
               <el-form-item label="" class="label-bold mt_16" prop="banner">
                   <div class="image_outer_wrap">
                       <ul  class="upload_image_list">
                           <li v-for="(item,index) in formData.banner"
                               :key="index"
                               class="upload_image_item">
                               <i @click="formData.banner.splice(index,1)" class="el-icon-error"></i>
                               <el-image
                                       :preview-src-list="formData.banner.map(img=>img.file_path)"
                                       :src="item.file_path"
                                       fit="cover">
                               </el-image>

                           </li>
                           <li class="image_upload_wrap">
                               <input accept=".png, .jpg, .jpeg"
                                      class="upload_input"
                                      multiple
                                      type="file"
                                      @change="handleClickUploadImg($event)">
                               <i class="el-icon-plus"></i>
                           </li>
                       </ul>
                       <p class="image_hint">请上传686 x 606像素，格式为PNG/JPG，大小不超过2M的图片</p>
                   </div>
               </el-form-item>

               <div class="title">
                   <span><i>*</i>商家联系人电话</span>
               </div>

               <el-form-item label="" class="label-bold mt_16" prop="contact_phone">
                    <el-input placeholder="请输入手机号" maxlength="11" class="width293" v-model="formData.contact_phone"></el-input>
                    <p class="hint">用户在小程序联系商家时所拨打的电话</p>
               </el-form-item>
           </el-form>
           <div class="btns">
               <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定</el-button>
           </div>

       </div>
    </div>
</template>
<script>
import {getWxCompanyDetail,  setWxCompanyEdit} from "@/api/index.js"
import { formatFileSize} from '@/utils'
import {uploadImg} from '@/utils/uploadOss'
export default {
    name: 'WeChatIndex',
    data () {
        return {
            btnDisabled:false,
            formData:{
                contact_phone:'',
                banner:[],
            },
            formDataRules:{
                contact_phone: [{ required: true,trigger: "blur", validator: (rule, value, callback) => {
                        const phoneRegex = /^1[3-9]\d{9}$/; // 正则表达式，匹配中国大陆手机号
                        if (!value) {
                            callback(new Error('请输入手机号'));
                        } else if (!phoneRegex.test(value)) {
                            callback(new Error('请输入有效的手机号'));
                        } else {
                            callback(); // 校验通过
                        }
                    } }],
                banner: [{ required: true, message: '请上传商品详情轮播图',trigger: "blur" }],
            },
        }
    },
    created() {
        this.getWxCompanyDetail()
    },
    mounted () {

    },
    methods: {
        getWxCompanyDetail(){
            let postData = {}
            this.loading = true
            getWxCompanyDetail(postData).then(res=> {
                if(res.code === 200) {
                    let {home_swiper_list,contact_phone} = res.data.company_infomation
                    this.formData.banner = home_swiper_list ? home_swiper_list : []
                    this.formData.contact_phone = contact_phone
                }
                this.loading = false
            })
        },
        handleClickConfirm(){
            this.$refs.formData.validate(valid => {
               if (valid) {
                   let postData = {
                       home_swiper_list:this.formData.banner,
                       contact_phone:this.formData.contact_phone,
                   }
                   this.btnDisabled = true
                   setWxCompanyEdit(postData).then(res=> {
                       if(res.code === 200) {
                            this.$message.success('设置成功')
                       }
                       this.btnDisabled = false
                   })
               }
            })
        },
        handleClickUploadImg(e) {
            const files = Array.from(e.target.files)
            if (this.formData.banner.length === 10) return this.$message.error('最多只能上传10张图片')
            if(files.length + this.formData.banner.length > 10) return this.$message.error('最多只能上传10张图片')
            files.forEach(file => {
                if(file.type != 'image/png' && file.type != 'image/jpeg'){
                    this.$message.error(`${file.name}文件格式不正确`)
                    return false
                }
                uploadImg(file, 2).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        res.file_type = file.type
                        this.formData.banner.push(res)
                        this.$refs.formData.validateField('banner')
                        e.target.value = ''
                    }
                }).catch(error => {
                    e.target.value = ''
                })

            })
        },
    },
    components: {

    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
</style>
